import { render, staticRenderFns } from "./TemplateFilter.vue?vue&type=template&id=520c70df&"
import script from "./TemplateFilter.vue?vue&type=script&lang=js&"
export * from "./TemplateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports